import React from 'react';

import DefaultOrgLogo from '../../assets/images/company-logo.png';
import { useGetOrganizationsForReferralQuery } from '../../redux/apis/organizationApi';
import { BaseSelect } from '../shared/BaseSelect/BaseSelect';

export const OrganizationSelect = ({
  onChange,
  value,
  placeholder = 'Select a company',
  isDisabled = false,
  isClearable = true,
  className,
  hasError = false,
  ...otherProps
}) => {
  const { data: organizations } = useGetOrganizationsForReferralQuery();

  const options = (organizations?.payload?.organizations || []).map((org) => ({
    label: org.name,
    value: org.id,
    logo: org.logo_image_thumb,
    organization: org,
  }));

  const formatOptionLabel = ({ label, logo }) => (
    <div className="flex items-center gap-2">
      {logo ? (
        <img src={logo} alt={label} className="object-cover w-5 h-5 rounded-sm" />
      ) : (
        <img src={DefaultOrgLogo} alt={label} className="object-cover w-5 h-5 rounded-sm" />
      )}
      <span>{label}</span>
    </div>
  );

  return (
    <BaseSelect
      options={options}
      value={options.find((opt) => opt.value === value)}
      onChange={onChange}
      placeholder={placeholder}
      formatOptionLabel={formatOptionLabel}
      isClearable={isClearable}
      isDisabled={isDisabled}
      className={className}
      hasError={hasError}
      menuMaxHeight="200px"
      {...otherProps}
    />
  );
};
